import "@scss/main.scss";
import 'debug/debug';
import dom_ready from './tools/dom-ready';
import dom_elements from './main/dom-elements';
import { initFx } from './fx/init';
import { initScroll } from './scroll/init';
import { SmoothScroll } from './scroll/SmoothScroll.js';
import { registerCookiesSystem } from "./lib/cookies-banner";
import { initNav } from './navs/init';
import { initAntiSpam } from './security/anti-spam';
import { initDataAttributes } from "./data-attritbutes/init";
import { initSections } from "./sections/init.js";

const userAgent = navigator.userAgent || "";
const vendor = navigator.vendor || "";
const platform = navigator.platform || "";
const maxTouchPoints = navigator.maxTouchPoints || 0;
const searchParams = new URLSearchParams(window.location.search);
const isIOSUserAgent = /\b(iPhone|iPad|iPod)\b/.test(userAgent);
const isTouchMac = platform === "MacIntel" && maxTouchPoints > 1;
const isSafariBrowser = /Safari/.test(userAgent)
    && !/Chrome|CriOS|EdgiOS|FxiOS|OPiOS|DuckDuckGo/.test(userAgent)
    && /Apple/i.test(vendor);
const hasMobileViewport = window.matchMedia("(max-width: 1024px)").matches;
const hasNoHover = window.matchMedia("(hover: none)").matches;
const hasAnyNoHover = window.matchMedia("(any-hover: none)").matches;
const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
const hasAnyCoarsePointer = window.matchMedia("(any-pointer: coarse)").matches;
const isSafariMobileViewport = hasMobileViewport && (hasNoHover || hasCoarsePointer);
const forceIosSafariParam = searchParams.get("force-ios-safari");
const storedForceIosSafari = window.localStorage.getItem("force-ios-safari");

if (forceIosSafariParam === "1") {
    window.localStorage.setItem("force-ios-safari", "1");
}

if (forceIosSafariParam === "0") {
    window.localStorage.removeItem("force-ios-safari");
}

const isForcedIosSafari = forceIosSafariParam === "1" || storedForceIosSafari === "1";
const shouldApplyIosSafariClass = isForcedIosSafari
    || (isSafariBrowser && (isIOSUserAgent || isTouchMac || isSafariMobileViewport));

if (shouldApplyIosSafariClass) {
    document.documentElement.classList.add("is-ios-safari");
}

// - Generic Safari detector (desktop + iOS), independent from the iOS/touch/mobile-viewport
//   heuristics above. Some rendering bugs (e.g. subgrid row miscalculation) reproduce on any
//   Safari engine regardless of device, and shouldn't be gated behind the mobile-only checks
//   used for `is-ios-safari`.
if (isSafariBrowser) {
    document.documentElement.classList.add("is-safari");
}

console.groupCollapsed("[LIGHT] iOS Safari detection");
console.table({
    userAgent,
    vendor,
    platform,
    maxTouchPoints,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    isIOSUserAgent,
    isTouchMac,
    isSafariBrowser,
    hasMobileViewport,
    hasNoHover,
    hasAnyNoHover,
    hasCoarsePointer,
    hasAnyCoarsePointer,
    isSafariMobileViewport,
    isForcedIosSafari,
    shouldApplyIosSafariClass,
    classApplied: document.documentElement.classList.contains("is-ios-safari"),
    classAppliedSafari: document.documentElement.classList.contains("is-safari"),
});
console.groupEnd();

dom_ready().then(_dom => {

    if (!window.location.hash && document.body.classList.contains('page-home')) {
        history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
    }

    // initAnimations();
    initFx();

    new SmoothScroll();

    // initScroll();

    initNav();

    registerCookiesSystem();

    initAntiSpam();

    initSections();

    // initDataAttributes();

// async function waitForStableLayout(el) {
//   // 1) après render
//   await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

//   // 2) fonts
//   if (document.fonts?.ready) await document.fonts.ready;

//   // 3) images dans el (celles déjà dans le DOM)
//   const imgs = [...el.querySelectorAll('img')].filter(img => !img.complete);
//   await Promise.all(imgs.map(img => new Promise(res => {
//     img.addEventListener('load', res, { once: true });
//     img.addEventListener('error', res, { once: true });
//   })));
// }

// async function measureContentHeight(el) {
//   await waitForStableLayout(el);
//   return el.scrollHeight;
// }

// document.querySelectorAll(".sticky-accordeon").forEach(async section => {
//   const accordeons = section.querySelector('.accordeons');
//   const h = await measureContentHeight(accordeons);
//   section.style.minHeight = `${h}px`;
// });

    // document.querySelectorAll(".sticky-accordeon").forEach(section => {
    //     const accordeons = section.querySelector('.accordeons');
    //     if (!accordeons) return;

    //     const ro = new ResizeObserver(() => {
    //         // scrollHeight donne la hauteur totale du contenu
    //         const h = accordeons.scrollHeight;
    //         section.style.minHeight = `${h}px`;
    //     });

    //     ro.observe(accordeons);

    //     // Optionnel : 1ère mesure après render
    //     requestAnimationFrame(() => {
    //         section.style.minHeight = `${accordeons.scrollHeight}px`;
    //     });
    // });
    // document.querySelectorAll(".sticky-accordeon")?.forEach(section => {
    //     const accordeons = section.querySelector('.accordeons');
    //     console.log(section.scrollHeight, section.getBoundingClientRect().height, accordeons.scrollHeight, accordeons.getBoundingClientRect().height);

    //     setInterval(() => {
    //         console.log(section.scrollHeight, section.getBoundingClientRect().height, accordeons.scrollHeight, accordeons.getBoundingClientRect().height);
    //     }, 1000);

    // });

});

dom_elements.then(_domElements => {

    document.documentElement.classList.add('init');

    setTimeout(() => {

        document.documentElement.classList.add('anim');
        document.querySelector('#main_nav').classList.add('animate', 'active');

    }, 600);

});
